/* cl-collection: filtros, ordenacao, densidade da grade e galeria dos cards da colecao
   copiada (o scope remove todo <script> do concorrente). Filtros = parametros nativos do
   Shopify (filter.v.availability, filter.v.price.gte/lte, sort_by) via GET. */
(function(){
  function each(r, s, fn){ [].forEach.call(r.querySelectorAll(s), fn); }

  function initFacets(root){
    var form = root.querySelector('form.clx-facets__form');
    if (!form || form.__cl) return; form.__cl = true;
    var url = new URL(location.href), params = url.searchParams;

    /* estado inicial a partir da URL */
    each(root, 'input[name="filter.v.availability"]', function(i){ i.checked = params.getAll(i.name).indexOf(i.value) > -1; });
    each(root, 'input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]', function(i){ if (params.get(i.name)) i.value = params.get(i.name); });
    var sort = params.get('sort_by');
    if (sort) {
      each(root, 'input[name="sort_by"]', function(i){
        i.checked = i.value === sort;
        var opt = i.closest('.sorting-filter__option');
        if (opt) opt.setAttribute('aria-selected', i.checked ? 'true' : 'false');
        if (i.checked) each(root, '.sorting-filter .facets__status', function(s){ s.textContent = i.getAttribute('data-option-name'); });
      });
    }
    each(root, 'cl-facet-status-component [ref="facetStatus"]', function(st){
      var det = st.closest('details'); if (!det) return;
      var n = det.querySelectorAll('input[type="checkbox"]:checked').length;
      if (n) st.textContent = '(' + n + ')';
    });

    function go(){
      var q = new URLSearchParams();
      var fd = new FormData(form);
      /* radios de ordenacao usam form="..." e ja entram no FormData */
      fd.forEach(function(v, k){ if (k === 'grid' || v === '' || v == null) return; q.append(k, v); });
      var act = form.getAttribute('action') || location.pathname;
      location.href = act + (q.toString() ? '?' + q.toString() : '');
    }
    var timer;
    function onChange(e){
      var t = e.target; if (!t || !t.name) return;
      if (t.name === 'grid') return;
      if (t.classList.contains('price-facet__input')) { clearTimeout(timer); timer = setTimeout(go, 700); return; }
      go();
    }
    form.addEventListener('change', onChange);
    each(root, 'input[name="sort_by"][form]', function(i){ i.addEventListener('change', onChange); });
    form.addEventListener('submit', function(e){ e.preventDefault(); go(); });

    /* Rensa (por filtro) e Rensa alla */
    each(root, '.facets__clear, .clear-filter', function(b){
      b.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var det = b.closest('details');
        if (det) each(det, 'input', function(i){ if (i.type === 'checkbox') i.checked = false; else i.value = ''; });
        go();
      });
    });
    each(root, '.facets__clear-all-link', function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); location.href = form.getAttribute('action') || location.pathname; });
    });

    /* um painel aberto por vez; fecha ao clicar fora / Esc */
    /* filtro VERTICAL (site novo: barra lateral com acordeoes abertos) nao e dropdown */
    var dets = root.querySelector('[filter-style="vertical"], [form-style="vertical"]') ? [] :
      [].slice.call(root.querySelectorAll('details.facets__panel'));
    dets.forEach(function(d){
      d.addEventListener('toggle', function(){
        if (d.open) dets.forEach(function(o){ if (o !== d) o.open = false; });
        var s = d.querySelector('summary[aria-expanded]'); if (s) s.setAttribute('aria-expanded', d.open ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function(e){ dets.forEach(function(d){ if (d.open && !d.contains(e.target)) d.open = false; }); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') dets.forEach(function(d){ d.open = false; }); });

    /* densidade da grade (Standard / zoom-out) */
    var grid = root.querySelector('ul[product-grid-view]');
    function setView(v){ if (grid) grid.setAttribute('product-grid-view', v); try { sessionStorage.setItem('cl-grid-view', v); } catch(e){} }
    each(root, 'input[name="grid"]', function(i){ i.addEventListener('change', function(){ if (i.checked) setView(i.value === 'zoom-out' ? 'zoom-out' : (i.value === 'mobile-single' ? 'mobile-single' : 'default')); }); });
    try { var saved = sessionStorage.getItem('cl-grid-view'); if (saved && grid) { setView(saved); each(root, 'input[name="grid"]', function(i){ i.checked = i.value === saved; }); } } catch(e){}
  }

  /* galeria do card: setas percorrem as fotos do produto */
  function initCard(card){
    if (card.__cl) return; card.__cl = true;
    var slides = [].slice.call(card.querySelectorAll('cl-slideshow-slide'));
    if (slides.length < 2) return;
    var idx = 0;
    var scroller = card.querySelector('cl-slideshow-slides');
    function show(i){
      idx = (i + slides.length) % slides.length;
      slides.forEach(function(s, k){ s.setAttribute('aria-hidden', k === idx ? 'false' : 'true'); });
      if (scroller && scroller.scrollWidth > scroller.clientWidth + 2) {
        scroller.scrollTo({left: slides[idx].offsetLeft - scroller.offsetLeft, behavior: 'smooth'});
      } else {
        slides.forEach(function(s, k){ s.style.display = k === idx ? '' : 'none'; });
      }
    }
    each(card, '.slideshow-control--previous', function(b){ b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); show(idx - 1); }); });
    each(card, '.slideshow-control--next', function(b){ b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); show(idx + 1); }); });
  }

  /* quick add: "Valj" leva ao produto; "Lagg till" submete o form (a gaveta intercepta) */
  function initQuickAdd(root){
    each(root, '.quick-add__button--choose', function(b){
      if (b.__cl) return; b.__cl = true;
      b.addEventListener('click', function(e){
        e.preventDefault();
        var card = b.closest('cl-product-card'); var a = card && card.querySelector('a.product-card__link');
        if (a) location.href = a.getAttribute('href');
      });
    });
  }

  function boot(){
    each(document, '[class*="cl-sec-"]', function(sec){
      if (sec.querySelector('form.clx-facets__form')) initFacets(sec);
      initQuickAdd(sec);
    });
    each(document, '[class*="cl-sec-"] cl-product-card', initCard);
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
